import { render, staticRenderFns } from "./AccountHeader.vue?vue&type=template&id=a97166f4"
import script from "./AccountHeader.vue?vue&type=script&lang=ts"
export * from "./AccountHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports